// extracted by mini-css-extract-plugin
module.exports = {"downloadButtonPDFWrapper":"bPXiY"};